import { LOGIN_SUCCESS, REGISTRATION_DETAIL_COMPLETE } from '@comeon/actions-public';

import Cookies from '@comeon/tomcat-cookies';

const domain = window.location.hostname.replace('mobile.', '').replace('www', '');

function removeSessionTime() {
	Cookies.remove('loggedInTime', {
		domain
	});
	// Remove the cookies used in player info screen for Germany
	Cookies.remove('playerInfoLastShown');
	Cookies.remove('playerInfoAccepted');
}
function setSessionTime() {
	Cookies.remove('loggedInTime');
	removeSessionTime();
	Cookies.set('loggedInTime', Date.now(), {
		domain
	});
}

const authMiddleware = () => {
	// const isResponsive = true;

	return store => next => action => {
		try {
			switch (action.type) {
				case LOGIN_SUCCESS:
				case REGISTRATION_DETAIL_COMPLETE: {
					setSessionTime();
					const { email } = store.getState().authentication;
					window.localStorage.setItem('login-form', JSON.stringify({ username: '', email }));
					break;
				}
				default: {
					break;
				}
			}
			return next(action);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Caught an exception!', error);
			throw error;
		}
	};
};

export default authMiddleware;
